module.exports = __webpack_public_path__ + "static/img/btn1-checked.de7292d1.png";